'use client';

import { useRef, useState } from 'react';
import type { BranchId } from '@/shared/config/funnel/constants';
import { DialogRoot } from '@/shared/ui/DialogRoot/DialogRoot';
import type { ExitIntentSignal } from '../../config/exitIntent';
import { createExitIntentTrigger, type ExitIntentTrigger } from '../../model/exit-intent/session';
import { useDesktopMouseLeaveSignal } from '../../model/exit-intent/useDesktopMouseLeaveSignal';
import { useEdgeSwipeSignal } from '../../model/exit-intent/useEdgeSwipeSignal';
import { useIdleSignal } from '../../model/exit-intent/useIdleSignal';
import { useScrollBounceSignal } from '../../model/exit-intent/useScrollBounceSignal';
import { useVisibilityReturnSignal } from '../../model/exit-intent/useVisibilityReturnSignal';
import { ExitModal } from './ExitModal';
import { useExitModalCloseAction } from './ExitModal/useExitModalCloseAction';
export function ExitIntentModal({
  branchId
}: {
  branchId: BranchId | null;
}) {
  const [signal, setSignal] = useState<ExitIntentSignal | null>(null);
  const [hasFired, setHasFired] = useState(false);
  const spentRef = useRef(false);
  const triggerRef = useRef<ExitIntentTrigger | undefined>(undefined);
  triggerRef.current = createExitIntentTrigger({
    spentRef,
    onFire: firedSignal => {
      setSignal(firedSignal);
      setHasFired(true);
    }
  });
  useDesktopMouseLeaveSignal(triggerRef, hasFired);
  useIdleSignal(triggerRef, hasFired);
  useScrollBounceSignal(triggerRef, hasFired);
  useEdgeSwipeSignal(triggerRef, hasFired);
  useVisibilityReturnSignal(triggerRef, hasFired);
  const {
    featureViewedActivityId,
    fireCloseAction
  } = useExitModalCloseAction(branchId);
  if (!signal) return null;
  return <DialogRoot open modal="trap-focus" onOpenChange={isOpen => {
    if (isOpen) return;
    fireCloseAction();
    setSignal(null);
  }}>
      <ExitModal featureViewedActivityId={featureViewedActivityId} branchId={branchId} />
    </DialogRoot>;
}